

// You can use it as state property
const state = () => ({
    booking: {
        contactName: '',
        contactCompany: '',
        contactEmail: '',
        contactAddress1: '',
        contactAddress2: '',
        contactAddress3: '',
        contactTown: '',
        contactCounty: '',
        contactPostcode: '',
        contactPhone: '',
        customerPoRef: '',
        invoiceName: '',
        invoiceCompany: '',
        invoiceEmail: '',
        invoiceAddress1: '',
        invoiceAddress2: '',
        invoiceAddress3: '',
        invoiceTown: '',
        invoiceCounty: '',
        invoicePostcode: '',
        invoicePhone: '',
    },
    contact: {},
    invoiceContact: {},
})

// You can use it as a state getter function (probably the best solution)
const getters = {
    booking(state) {
        return state.booking
    },
    contact(state) {
        return state.contact
    },
    invoiceContact(state) {
        return state.invoiceContact
    }
}

// Mutation for when you use it as state property
const mutations = {
    updateBooking(state, payload) {
        state.booking = payload
    },

    updateContact(state, payload) {
        state.contact = payload
    },

    updateInvoiceContact(state, payload) {
        state.invoiceContact = payload
    }
}
const actions = {


    updateBooking({commit}, payload) {
        commit('updateBooking', payload)
    },
    updateContact({commit}, payload) {
        commit('updateContact', payload)
    },
    updateInvoiceContact({commit}, payload) {
        commit('updateInvoiceContact', payload)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}